import React from 'react';
import { Form, Select, Checkbox } from 'antd';
import converPricingValue from 'util/convertPricingValue';
import { BRAND_LEVEL } from 'constants/DefineConst';

const { Option } = Select;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

const getLimitFreq = (maxFrequency, freq) => {
  switch(maxFrequency) {
    case 'Yearly':
      return freq;
    case 'Quarterly':
      return freq.filter(item => item.name !== 'Yearly');
    case 'Monthly':
      return freq.filter(item => !['Yearly', 'Quarterly'].includes(item.name));
    case 'Biweekly':
      return freq.filter(item => !['Yearly', 'Quarterly', 'Monthly'].includes(item.name));
    case 'Weekly':
      return freq.filter(item => !['Yearly', 'Quarterly', 'Monthly', 'Biweekly'].includes(item.name));
    default:
      return freq.filter(item => item.name === 'Daily');
  }
}

class EditableCell extends React.Component {
  state = {
    editing: true,
  };

  componentDidUpdate(prevProps) {
    if (this.props.isReset !== prevProps.isReset && this.props.isReset) {
      this.form.resetFields();
    }
  }

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = (key, inputValue = '') => {
    const { record, handleSave, handleFetchSampleSize, handleShowBSIMsg } = this.props;
    const value = inputValue;
    if (record.sow === 'Sample') {
      handleFetchSampleSize(key, value);
    }
    if (record.sow === 'BSI' && value === 1) {
      handleShowBSIMsg(true);
    }
    handleSave({ ...record, [key]: value });
  };

  renderCell = form => {
    this.form = form;
    const {
      children,
      dataIndex,
      record,
      loadingFreq,
      freq,
      maxFrequency,
      isEmptyComp,
      // dataComp
    } = this.props;
    const { editing } = this.state;
    const limitFreq = getLimitFreq(maxFrequency, freq);
    // let isPassedComp = false;
    // let comp = 0;
    // if (dataIndex.includes('brand')) {
    //   const key = getKeyFromDataComp(dataIndex);
    //   comp = dataComp[0][key.name] ? dataComp[0][key.name].next : 0;
    //   isPassedComp = comp >= 60000;
    // }
    // let formItem = !isPassedComp && !isEmptyComp && comp !== 0 && record.sow === 'Sample' ? <div style={{ color: 'red' }}><Tooltip title='Giá của brand không thỏa điều kiện để chọn sample'><Icon type="warning" /></Tooltip></div> : <Form.Item style={{ margin: 0, marginLeft: 42 }}>
    //   {form.getFieldDecorator(dataIndex, {
    //     initialValue: record[dataIndex],
    //   })(<Checkbox disabled={(!isPassedComp || isEmptyComp) && record.sow === 'Sample'} checked={record[dataIndex]} onChange={e => this.save(dataIndex, e.target.checked * 1)} ref={node => (this.input = node)} />)}
    // </Form.Item>

    let formItem = <Form.Item style={{ margin: 0, marginLeft: 42 }}>
    {form.getFieldDecorator(dataIndex, {
      initialValue: record[dataIndex],
    })(<Checkbox disabled={isEmptyComp && record.sow === 'Sample'} checked={record[dataIndex]} onChange={e => this.save(dataIndex, e.target.checked * 1)} ref={node => (this.input = node)} />)}
    </Form.Item>

    if (dataIndex === 'freq') {
      if (['Sample', 'BSI','Data Management', 'Charting & Analysis', 'Project Management', 'Client Service', 'General Management', 'Unit Cost'].includes(record.sow)) {
        formItem = record[dataIndex];
      } else {
        formItem = <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(dataIndex, {
          initialValue: record[dataIndex] || (limitFreq && limitFreq[limitFreq.length - 1] && [limitFreq[limitFreq.length - 1].name]),
        })(<Select placeholder='Frequency' loading={loadingFreq} ref={node => (this.input = node)} style={{ width: 100 }} onChange={e => this.save(dataIndex, e)}>
          {limitFreq.map(item => <Option key={`${item.key}_${record.key}`} value={item.name}>{item.name}</Option>)}
        </Select>)}
      </Form.Item>
      }
    }

    if (['brand1', 'brand2', 'brand3', 'brand4', 'brand5', 'brand6', 'brand7', 'brand8', 'brand9', 'brand10'].includes(dataIndex)) {
      if (['Data Management', 'Project Management', 'Client Service', 'General Management'].includes(record.sow)) {
        formItem = null;
      }
      if (record.sow === 'Unit Cost') {
        formItem = record[dataIndex] ? converPricingValue(record[dataIndex]) : '';
      }
      if (record.sow === 'Charting & Analysis') {
        formItem = <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(dataIndex, {
          initialValue: isEmptyComp ? 'none' : record[dataIndex] || 'none',
        })(<Select ref={node => (this.input = node)} style={{ width: 100 }} onChange={e => this.save(dataIndex, e)}>
          <Option value="none">Bỏ chọn</Option>
          {Object.keys(BRAND_LEVEL).map(l => <Option key={BRAND_LEVEL[l].key} value={BRAND_LEVEL[l].key}>{BRAND_LEVEL[l].value}</Option>)}
        </Select>)}
      </Form.Item>
      }
    }

    return editing ? (
      formItem
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24 }}
        onClick={this.toggleEdit}
      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      handleShowBSIMsg, 
      handleFetchSampleSize,
      children,
      isReset,
      isEmptyComp,
      loadingFreq,
      maxFrequency,
      freq,
      dataComp,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}

export {
  EditableFormRow,
  EditableCell,
}
